var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenCheckGiftCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 78,
    r: 77,
    fill: "#EAFFEA",
    stroke: "#28E924",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78 126.8C104.951 126.8 126.8 104.952 126.8 78.0002C126.8 51.0487 104.951 29.2002 78 29.2002C51.0485 29.2002 29.2 51.0487 29.2 78.0002C29.2 104.952 51.0485 126.8 78 126.8ZM100.613 70.1135C102.995 67.7313 102.995 63.869 100.613 61.4868C98.2311 59.1046 94.3688 59.1046 91.9866 61.4868L71.9 81.5735L64.0133 73.6868C61.6311 71.3046 57.7688 71.3046 55.3866 73.6868C53.0044 76.069 53.0044 79.9313 55.3866 82.3135L67.5866 94.5135C69.9688 96.8957 73.8311 96.8957 76.2133 94.5135L100.613 70.1135Z",
    fill: "#28E924"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckGiftCard);
export default __webpack_public_path__ + "static/media/green-check-gift-card.30b7b7a153b42a149c4de1ea1f8b3c52.svg";
export { ForwardRef as ReactComponent };